<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.yeni_proje_akisi"  url="FlowAudit" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<div class="mt-4">


<div class="grid">


<template v-if="$route.params.auditday_id">
  <div class="col-11">
  <ClickEditSelect title="Soru Listesi" :value="item.questionlist_id" :options="questionlists" valkey="questionlist_id" @dataChanged="dataChanged"  :filter="true"/>
  </div>
  <div class="col-1">
<Button type="button"  icon="pi pi-external-link"  class="p-button-primary p-button-outlined p-button-sm mt-3"  @click="gotoQuList" />
  </div>

</template>

<template v-else>
  <div class="col-12">
    <ClickEditSelect title="Soru Listesi" :value="item.questionlist_id" :options="questionlists" valkey="questionlist_id" @dataChanged="dataChanged"  :filter="true"/>
  </div>
</template>



</div>



<ClickEditNumber  title="Denetleme Süresi (saat)" :value="item.duration" valkey="duration" @dataChanged="settingsChanged"   />


<ClickEditSwitch  :title="$store.state.languages.lang_phrases.teknik_denetleme_gerekli" :value="item.requires_tech_audit" valkey="requires_tech_audit" @dataChanged="settingsChanged" />

<ClickEditSwitch  :title="$store.state.languages.lang_phrases.online" :value="item.is_online" valkey="is_online" @dataChanged="settingsChanged" />


<ClickEditMultiSelect :title="$store.state.languages.lang_phrases.iliskili_ozel_nitelikler" :value="item.customattributes" :options="custom_attributes" valkey="customattributes" @dataChanged="settingsChanged"  />

<ClickEditMultiSelect :title="$store.state.languages.lang_phrases.gerekli_belgeler" :value="item.required_certificates" :options="certificate_types" valkey="requiredcertificates" @dataChanged="settingsChanged" :showaschips="false" />

<ClickEditMultiSelect :title="$store.state.languages.lang_phrases.muafiyet_sertifikalari" :value="item.exemption_certificates" :options="certificate_types" valkey="exemptioncertificates" @dataChanged="settingsChanged"  :showaschips="false" />




</div>
</template>

<FlowQuestionlistCloneModal @questionlistselected="questionlistselected"></FlowQuestionlistCloneModal>
</div>
</template>
<script>
import FlowQuestionlistCloneModal from "./FlowQuestionlistCloneModal"
export default {

  name: 'FlowAuditDay',
  components:{FlowQuestionlistCloneModal},
  data () {
    return {
      loading:true,
      questionlists:[],
      item:{questionlist_id:null,duration:null},
      custom_attributes:[],
      certificate_types:[],
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
    questionlistselected(fields)
    {
      let formdata = this.createFormData(JSON.parse(JSON.stringify(fields)))
      formdata.append("auditday_id",this.$route.params.auditday_id) 
      formdata.append("questionlist_id",this.$store.state.flows.qu_list_to_clone.id)  
      this.generalSubmission(formdata,"auditday/clone_list",this.afterquestionlistselected)
    },
    afterquestionlistselected(response)
    {
      this.$store.dispatch('flows/setShowCloneModal',false) 
      console.log(response.data) 
      this.gotoPage('Questionlist',{id:response.data.id})
    },
    async resolveCustomAttributes(item)
    {
       item.customattributes = await []
        for(let element of item.auditdayattributes)
        {
          let customattribute = await element.customattribute
          await item.customattributes.push(customattribute)
        }


       item.required_certificates = await []
       for(let element of item.requiredcertificates)
        {
          let certificatetype = await element.certificatetype
          await item.required_certificates.push(certificatetype)
        }
       item.exemption_certificates = await []
       for(let element of item.exemptioncertificates)
        {
          let certificatetype = await element.certificatetype
          await item.exemption_certificates.push(certificatetype)
        }

        return await item
    },
  	async getData()
  	{
      this.loading = await true
      this.custom_attributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$store.state.flows.flow.brand_id)
      this.certificate_types = await this.generalApiGetWithoutLoader("certificatetypes")
      //await this.certificate_types.push({id:0,name:"Yeni ekle"})
      await console.log(this.custom_attributes)
  		let questionlists = await this.generalApiGetWithoutLoader("questionlists")
  		await console.log(questionlists)
  		for(let item of questionlists)
        {
          if(item.brand_id == this.$store.state.flows.flow.brand_id)
          {

            
          }
          else
          {
            item.name = item.name+" - "+item.brand.name+" - kopyasını oluştur"
          }          
        }

        await questionlists.push({name:"Soru Listesi Oluştur",id:0})
        this.questionlists = await questionlists   
        if(this.$route.params.auditday_id)
        {
          let item = await this.generalApiGetWithoutLoader("auditday/"+this.$route.params.auditday_id)
          item = await this.resolveCustomAttributes(item)
          console.log(item)
          this.item = await item
        }
        
        this.loading = await false    
  	},

    dataChanged(data)
    {
      console.log(data)      
      if(data.value==0)
      {
        this.gotoPage('FlowAuditdayNewQuestionlist')
      }
      else
      {

        let item = this.questionlists.find((item)=>{return item.id == data.value})
        console.log(item)
        console.log(this.$store.state.flows.flow.brand_id)
        if(item.brand_id !== this.$store.state.flows.flow.brand_id)
        {
          this.$store.dispatch('flows/setQuListToClone',item) 
          this.$store.dispatch('flows/setShowCloneModal',true) 
          return false
        }

        let formdata = new FormData()
        formdata.append("auditday_id",this.$route.params.auditday_id) 
        formdata.append("questionlist_id",data.value) 
        this.generalSubmission(formdata,"auditday/append_questionlist",this.afterSubmit)
      }
    },
    async afterSubmit(response)
    {
        //console.log(response.data) 
        //this.$store.dispatch('flows/setFlow',response.data)
        let item = await response.data
        item =  await this.resolveCustomAttributes(item)
        this.item = await  item
      
    },
    gotoQuList()
    {
      this.gotoPage('Questionlist',{id:this.item.questionlist_id})
    },
    settingsChanged(data)
    {
      console.log(data.key)
      console.log(data.value)
      //return false
      let formdata = new FormData()
      if(data.key=="customattributes"||data.key=="requiredcertificates"||data.key=="exemptioncertificates")
      {
        formdata.append(data.key,JSON.stringify(data.value))
      }
      else
      {
        formdata.append(data.key,data.value) 
      }
      
      this.generalSubmission(formdata,"auditday/"+this.$route.params.auditday_id,this.afterSubmit)
    },
  	
  }
}
</script>

<style lang="css" scoped>
</style>